"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProgram = exports.incentivesDistributionError = exports.SET_START_TIME_EVENT = exports.SET_ADMIN_EVENT = exports.CLOSE_TREASURY_EVENT = exports.INIT_TREASURY_EVENT = exports.CLOSE_CLAIM_RECORD_EVENT = exports.CLAIM_AND_DEPOSIT_EVENT = exports.CLAIM_EVENT = exports.SET_CLAIM_RECORD_AMOUNT_EVENT = exports.INIT_CLAIM_RECORD_EVENT = exports.CLAIM_RECORD_ACCOUNT_SEED = exports.TREASURY_TOKEN_AUTHORITY_SEED = exports.INCENTIVES_DISTRIBUTION_PROGRAM_ID = exports.IncentivesDistributionIDL = exports.SEASON2_TREASURY = exports.REFERRERS_TREASURY = exports.MNDE_TREASURY = exports.STAKERS_TREASURY = void 0;
const generated = __importStar(require("../generated/incentives_distribution"));
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
const nodewallet_1 = __importDefault(require("@coral-xyz/anchor/dist/cjs/nodewallet"));
/**
 * Incentive Distribution contract Anchor IDL wrapper.
 *
 * All operations are performed through the program instance.
 *
 * To get PDA and read account data see ./api.ts
 * To execute contract operations see ./with*.ts
 */
exports.STAKERS_TREASURY = new web3_js_1.PublicKey('inTrQECqatDmvAt7ahYeWg82efX5PsxhiFXzQk9eKYG');
/**
 *  @deprecated, use {@link STAKERS_TREASURY} instead
 */
exports.MNDE_TREASURY = exports.STAKERS_TREASURY;
exports.REFERRERS_TREASURY = new web3_js_1.PublicKey('iNTrR8cP5Vw86X17sDNwuGxKyqR57sYZ8HvpRY7r1FF');
exports.SEASON2_TREASURY = new web3_js_1.PublicKey('iNtR2h6yAUDXawbiVBHVUBZ5qN3qsFCezZJABgfWT8h');
exports.IncentivesDistributionIDL = generated.IDL;
const IDL = exports.IncentivesDistributionIDL;
exports.INCENTIVES_DISTRIBUTION_PROGRAM_ID = new web3_js_1.PublicKey(JSON.parse(IDL.constants.find(x => x.name === 'PROGRAM_ID').value));
exports.TREASURY_TOKEN_AUTHORITY_SEED = JSON.parse(IDL.constants.find(x => x.name === 'TREASURY_TOKEN_AUTHORITY_SEED').value);
exports.CLAIM_RECORD_ACCOUNT_SEED = JSON.parse(IDL.constants.find(x => x.name === 'CLAIM_RECORD_ACCOUNT_SEED').value);
exports.INIT_CLAIM_RECORD_EVENT = 'InitClaimRecordEvent';
exports.SET_CLAIM_RECORD_AMOUNT_EVENT = 'SetClaimRecordAmountEvent';
exports.CLAIM_EVENT = 'ClaimEvent';
exports.CLAIM_AND_DEPOSIT_EVENT = 'ClaimAndDepositEvent';
exports.CLOSE_CLAIM_RECORD_EVENT = 'CloseClaimRecordEvent';
exports.INIT_TREASURY_EVENT = 'InitTreasuryEvent';
exports.CLOSE_TREASURY_EVENT = 'CloseTreasuryEvent';
exports.SET_ADMIN_EVENT = 'SetAdminEvent';
exports.SET_START_TIME_EVENT = 'SetStartTimeEvent';
exports.incentivesDistributionError = (0, anchor_1.parseIdlErrors)(IDL);
function getProgram({ connection, wallet, opts, programId = exports.INCENTIVES_DISTRIBUTION_PROGRAM_ID, }) {
    if (wallet instanceof web3_js_1.Keypair) {
        wallet = new nodewallet_1.default(wallet);
    }
    const provider = new anchor_1.AnchorProvider(connection, wallet, opts);
    return new anchor_1.Program(IDL, programId, provider);
}
exports.getProgram = getProgram;
//# sourceMappingURL=sdk.js.map